import { alpha as muiAlpha } from "@mui/material";
import { alphaVar as cssAlphaVar, isCssVarColor, tokenRefs } from "../../theme/tokens";

export const alphaVar = (color, opacity) => cssAlphaVar(color, opacity) ?? muiAlpha(color, opacity);

export const isThemeToken = isCssVarColor;

export const colors = tokenRefs.colors;

export const roleColors = tokenRefs.roleColors;

const statusTone = tokenRefs.statusColors;

const withSoftBackground = (color) => ({ color, bg: alphaVar(color, 0.12) });

export const jobColors = {
  forRevision: withSoftBackground(statusTone.forRevision),
  approved: withSoftBackground(statusTone.approved),
  scheduled: withSoftBackground(statusTone.scheduled),
  inProgress: withSoftBackground(statusTone.inProgress),
  completed: withSoftBackground(statusTone.completed),
  cancelled: withSoftBackground(statusTone.cancelled),
  visitJob: withSoftBackground(statusTone.visitJob),
  visitQuote: { color: statusTone.visitQuote, bg: statusTone.visitQuote },
};

export const avatarColorOptions = [
  colors.orange[500],
  colors.yellow[500],
  colors.blue[500],
  colors.success[500],
  colors.warning[500],
  colors.danger[500],
  colors.info[500],
];

export const subscriptionStatusColors = {
  active: withSoftBackground(statusTone.active),
  completed: withSoftBackground(statusTone.scheduled),
  failed: withSoftBackground(statusTone.failed),
  cancelled: withSoftBackground(statusTone.cancelledStrong),
  suspended: withSoftBackground(statusTone.suspended),
  approvalPending: withSoftBackground(statusTone.approvalPending),
};
